"use client";

import { useState } from "react";
import { Link } from "@tanstack/react-router";
import clsx from "clsx";
import { toAppPath } from "#/lib/router-links";
import LogoImage from "./LogoImage";
import LoginBtn from "./LoginBtn";
import UploadResumeBtn from "./UploadResumeBtn";

export default function NavBar({
  currentPath,
  overrideLinks,
}: {
  currentPath?: string;
  overrideLinks?: { href: string; text: string }[];
}) {
  const [isExpanded, setIsExpanded] = useState(true);

  // Determine the link based on the current route
  const locumLink =
    currentPath === "/locum-work-physicians-guide"
      ? { href: "/locum-tenens-agencies", text: "Locum Agencies" }
      : {
          href: "/locum-work-physicians-guide",
          text: "How Locum Works",
        };

  const secondLink = [
    "/recruit-anesthesia-providers",
    "/anesthesiologist-job-description-template",
  ].includes(currentPath ?? "random-1234")
    ? {
        href: "/anesthesiologist-job-description-template",
        text: "Job Description Template",
      }
    : { href: "/anesthesiologist-cv-examples", text: "CV Examples" };

  const thirdLink = [
    "/recruit-anesthesia-providers",
    "/anesthesiologist-job-description-template",
  ].includes(currentPath ?? "random-1234")
    ? {
        href: "/recruit-anesthesia-providers",
        text: "Recruiting Provider Tips",
      }
    : locumLink;

  let links = [
    { href: "/anesthesiologist-salary", text: "Anesthesiologist Salary" },
    secondLink,
    thirdLink,
  ];

  if (currentPath === "/home") {
    links = [
      {
        href: "/physician-job-search",
        text: "Search Physician Jobs",
      },
      { href: "/physician-salary-in-united-states", text: "Salary Guides" },
      {
        href: "/physician-cv-examples",
        text: "Resume CV Examples",
      },
    ];
  }

  if (overrideLinks) {
    links = overrideLinks;
  }

  return (
    <>
      <nav className="start-0 top-0 z-20 w-full border-b border-gray-200 bg-white">
        <div className="mx-auto flex max-w-screen-xl flex-wrap items-center justify-between p-4">
          <span className="flex items-center space-x-3 rtl:space-x-reverse">
            <LogoImage />
          </span>
          <div className="flex space-x-3 md:order-2 md:space-x-3 rtl:space-x-reverse">
            <UploadResumeBtn />
            <LoginBtn />
            <button
              data-collapse-toggle="navbar"
              type="button"
              className="inline-flex h-10 w-10 items-center justify-center rounded-lg p-2 text-sm text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200  md:hidden"
              aria-controls="navbar"
              aria-expanded="false"
              onClick={() => setIsExpanded(!isExpanded)}
            >
              <span className="sr-only">Open main menu</span>
              <svg
                className="h-5 w-5"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 17 14"
              >
                <path
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M1 1h15M1 7h15M1 13h15"
                />
              </svg>
            </button>
          </div>
          <div
            className={clsx(
              "w-full items-center justify-between md:order-1 md:flex md:w-auto",
              { hidden: !isExpanded },
            )}
            id="navbar"
          >
            <ul className="0 mt-4 flex flex-col rounded-lg border border-gray-200 bg-gray-50 p-4 font-medium md:mt-0 md:flex-row md:space-x-8 md:border-0 md:bg-white md:p-0 rtl:space-x-reverse ">
              {links.map((link) => (
                <li key={link.href}>
                  <Link
                    {...toAppPath(link.href)}
                    className="block rounded px-3 py-2 text-gray-900 hover:bg-gray-100  md:p-0 md:hover:bg-transparent md:hover:text-sky-700 "
                  >
                    {link.text}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </nav>
    </>
  );
}
